<template>
  <div class="insights-team-collaboration-pill">
    <label>{{ label }}</label>
    <div class="collaboration-pill">
      <i class="pill-icon material-symbols-rounded">{{ icon }}</i>
      <span>{{ text }}</span>
      <div
        v-if="providerIcons.length"
        class="provider-icons"
      >
        <img
          v-for="icon in providerIcons"
          :key="icon.alt"
          v-tooltip="tooltipOptions"
          class="provider-icon"
          :src="icon.src"
          :alt="icon.alt"
          :title="icon.tooltip"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { formatDuration } from '~/utils/time_utils';
import { numericValue } from '~/utils/insights_utils';
import { INSIGHTS, INSIGHTS_ASSETS } from '~/app_constants';

export default {
  name: 'InsightsTeamCollaborationPill',
  props: {
    type: {
      type: String,
      required: true,
    },
    value: {
      type: [Number, String],
      required: true,
    },
    property: {
      type: String,
      required: true,
    },
    // Integration types feeding the metric, in display order
    providers: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    tooltipOptions: Object.freeze({ placement: 'top' }),
  }),
  computed: {
    providerIcons() {
      return this.providers
        .filter((type) => INSIGHTS_ASSETS.collaboration_provider_logos[type])
        .map((type) => ({
          ...INSIGHTS_ASSETS.collaboration_provider_logos[type],
          tooltip: INSIGHTS.collaborations.providers[type].dataDelay,
        }));
    },
    text() {
      return this.property.includes('duration')
        ? formatDuration(this.value, { showSeconds: true })
        : numericValue(this.value);
    },
    icon() {
      return INSIGHTS.collaborations.icons[this.type][this.property] || 'info';
    },
    label() {
      return INSIGHTS.collaborations.labels[this.type][this.property];
    },
  },
};
</script>
